import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, range } from 'rxjs';
import { map, filter, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-filter-pagination',
  templateUrl: './filter-pagination.component.html',
  styleUrls: ['./filter-pagination.component.scss']
})
export class FilterPaginationComponent implements OnInit {
  @Input() offset: number; // current offset(current starting index-of record) (number of entries)
  @Input() limit: number; // record per page
  @Input() size: number; // total records
  @Input() range = 3;

  @Output() pageChange: EventEmitter<any>;
  currentPage: number;
  totalPages: number;
  pages: Observable<number[]>;

  constructor() {
    this.pageChange = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.getPages(this.offset, this.limit, this.size);
  }

  ngOnChanges(): void {
    this.getPages(this.offset, this.limit, this.size);
  }

  getPages(offset: number, limit: number, size: number): void {
    this.currentPage = this.getCurrentPage(offset, limit);
    this.totalPages = this.getTotalPages(limit, size);
    this.pages = range(-this.range, this.range * 2 + 1)
      .pipe(
        map(offset => this.currentPage + offset),
        filter(page => this.isValidPageNumber(page, this.totalPages)),
        toArray()
      );
  }

  getCurrentPage(offset: number, limit: number): number {
    return Math.floor(offset / limit) + 1;
  }

  getTotalPages(limit: number, size: number): number {
    return Math.ceil(Math.max(size, 1) / Math.max(limit, 1));
  }

  isValidPageNumber(page: number, totalPages: number): boolean {
    return page > 0 && page <= totalPages;
  }

  selectPage(page: number, event: any): void {
    event.preventDefault();
    if (this.isValidPageNumber(page, this.totalPages)) {
      this.pageChange.emit((page - 1) * this.limit);
    }
  }

  cancelEvent(event): void {
    event.preventDefault();
  }

}
